import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col md:flex-row items-center gap-6 p-8 md:p-10">
            <div className="w-20 h-20 md:w-24 md:h-24 shrink-0 flex items-center justify-center rounded-2xl bg-secondary-100/70 text-secondary-600">
              <i className={`${contactData.icon} text-3xl md:text-4xl`}></i>
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-lg md:text-xl font-black text-foreground-950">
                {contactData.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                {contactData.desc}
              </p>
              <div className="mt-3 inline-flex items-center gap-2 px-4 py-2 bg-background-100 rounded-lg">
                <i className="ri-mail-line text-foreground-500"></i>
                <span className="text-sm font-medium text-foreground-700">
                  {contactData.email}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}